<div class="modal-header">
	<h5 class="modal-title" *ngIf="state === OrderState.ACCEPTED">{{ 'orderComment.button.acceptOrder' | translate }}</h5>
	<h5 class="modal-title" *ngIf="state === OrderState.DECLINED">{{ 'orderComment.button.declineOrder' | translate }}</h5>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close(false)">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body">
	<h3 class="modal-comment-header">{{ 'orderComment.title' | translate }}</h3>
	<textarea
		rows="8"
		maxlength="2000"
		class="form-control"
		placeholder="{{ 'orderComment.placeholder' | translate }}"
		[(ngModel)]="comment"
	></textarea>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="close(false)">
		{{ 'orderComment.button.cancel' | translate }}
	</button>
	<button type="button" class="btn btn-primary" *ngIf="state === OrderState.ACCEPTED" (click)="close(true)">
		{{ 'orderComment.button.accept' | translate }}
	</button>
	<button type="button" class="btn btn-primary" *ngIf="state === OrderState.DECLINED" (click)="close(true)">
		{{ 'orderComment.button.decline' | translate }}
	</button>
</div>
